
export enum WebSocketTopicName {
    PENDING_MANUAL_IMPORTS_TOPIC = '/topic/lqb/pending/manual',
    QUEUED_SCHEDULED_TASKS_TOPIC = '/topic/schedules/queue'
}